<div class="toggle_view">
  <mat-button-toggle-group
    name="fontStyle"
    aria-label="Font Style"
    color="accent"
    class="m-3"
    *ngIf="isToggle"
  >
    <mat-button-toggle value="list" color="accent" (click)="onList()"
      ><mat-icon class="example-tab-icon">list</mat-icon></mat-button-toggle
    >
    <mat-button-toggle value="grid" (click)="onGrid()"
      ><mat-icon class="example-tab-icon"
        >view_module</mat-icon
      ></mat-button-toggle
    >
  </mat-button-toggle-group>
</div>

<div class="select_all" *ngIf="gridView">
  <div
    class="detail_entered"
    *ngFor="let pipelineDetail of pipelineDetails"
    (click)="onView(pipelineDetail)"
  >
    <div class="picture"></div>
    <div class="the_details">
      <h2 class="name">{{ pipelineDetail.PipelineName }}</h2>
      <div class="other_detail">
        <p class="entry">
          Pipeline Code:
          <span class="sub_element">{{ pipelineDetail.PipelineCode }}</span>
        </p>
        <p class="entry">
          Installation Year:
          <span class="sub_element">{{ pipelineDetail.InstallationYear }}</span>
        </p>
        <p class="entry">
          Licence Expiration Date:
          <span class="sub_element">{{
            pipelineDetail?.LicenceExpirationDate | date
          }}</span>
        </p>
      </div>
    </div>
  </div>
</div>

<div class="card" *ngIf="listView">
  <table class="table table-hover">
    <thead>
      <tr>
        <th scope="col">S/N</th>
        <th scope="col">Pipeline Name</th>
        <th scope="col">Pipeline Code</th>
        <th scope="col">Installation Year</th>
        <th scope="col">License Expiration Date</th>
        <th scope="col">Status</th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let pipelineDetail of pipelineDetails; index as i"
        (click)="onView(pipelineDetail)"
        style="cursor: pointer;"
      >
        <th scope="row">{{ i + 1 }}</th>
        <td>{{ pipelineDetail.PipelineName }}</td>
        <td>{{ pipelineDetail.PipelineCode }}</td>
        <td>{{ pipelineDetail?.InstallationYear }}</td>
        <td>{{ pipelineDetail?.LicenceExpirationDate | date }}</td>
        <td>{{ getLicenceStatusName(pipelineDetail?.LicenceStatusId) }}</td>
      </tr>
    </tbody>
  </table>
</div>
